module.exports = __webpack_public_path__ + "img/location.d2455b38.svg";